import React from 'react';
import { Icon, Frame, Link, SageClassnames, EmptyState, SageTokens } from '@kajabi/sage-react';
import useGeneratorTrackingCallback from 'common/components/CopyMagic/hooks/useGeneratorTrackingCallback';

type Props = {
  helpArticleLinkText: string;
  helpArticleLink: string;
};

const NullState = ({ helpArticleLink, helpArticleLinkText }: Props) => {
  const trackPromptArticleClicked = useGeneratorTrackingCallback('useTrackPromptArticleClicked');
  const nullStateText =
    'Give us a prompt and we’ll generate a few suggestions to get the ideas flowing!';

  return (
    <EmptyState
      data-testid="copy-magic-null-state"
      icon={SageTokens.ICONS.MEGAPHONE}
      backgroundColor={SageTokens.COLOR_PALETTE.RED_300}
      size={EmptyState.SIZES.COMPACT}
      text={nullStateText}
      actions={
        <Frame align={Frame.ALIGNMENTS.CENTER_CENTER}>
          <Link
            onClick={trackPromptArticleClicked}
            href={helpArticleLink}
            rel="noopener noreferrer"
            target="_blank"
            icon={Icon.ICONS.LAUNCH}
            iconPosition="right"
            style={Link.COLORS.SECONDARY}
            className={SageClassnames.TYPE.BODY_SMALL}
          >
            {helpArticleLinkText}
          </Link>
        </Frame>
      }
    />
  );
};

export default NullState;
